function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import classNames from "classnames";
// Row
export var Row = function Row(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("tui-row", props.className)
  }, props.children);
};

// Spacer
export var Spacer = function Spacer() {
  return /*#__PURE__*/React.createElement("div", {
    className: "tui-row tui-row-spacer"
  });
};

// Column
export var Col = function Col(props) {
  var colClasses = classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    "tui-col": true,
    "tui-col-xs": !props.xs
  }, "tui-col-xs-".concat(props.xs), props.xs), "tui-col-sm-".concat(props.sm), props.sm), "tui-col-md-".concat(props.md), props.md), "tui-col-lg-".concat(props.lg), props.lg), "tui-col-xs-offset-".concat(props.xsOffset), props.xsOffset), "tui-col-sm-offset-".concat(props.smOffset), props.smOffset), "tui-col-md-offset-".concat(props.mdOffset), props.mdOffset), "tui-col-lg-offset-".concat(props.lgOffset), props.lgOffset), props.className);
  return /*#__PURE__*/React.createElement("div", {
    className: colClasses
  }, props.children);
};
// Grid
export var Grid = function Grid(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("tui-grid", props.className, {
      "no-spacing": props.padded === false
    })
  }, props.children);
};
Grid.Col = Col;
Grid.Row = Row;
Grid.Spacer = Spacer;
//# sourceMappingURL=Grid.js.map